// file: web/src/components/AppBottomNav.tsx
"use client";

import { useRouter, usePathname } from "next/navigation";
import { Club, LayoutDashboard, Users, Wallet } from "lucide-react";

function cn(...xs: Array<string | false | null | undefined>) {
  return xs.filter(Boolean).join(" ");
}

type Tab = "dashboard" | "clubs" | "members" | "settlements";

function detectTab(pathname: string): Tab | null {
  if (pathname === "/" || pathname.startsWith("/dashboard")) return "dashboard";
  if (pathname.startsWith("/clubs")) return "clubs";
  if (pathname.startsWith("/members")) return "members";
  if (pathname.startsWith("/settlements")) return "settlements";
  return null;
}

export default function AppBottomNav() {
  const router = useRouter();
  const pathname = usePathname();
  const tab = detectTab(pathname);

  const navBtn = (active: boolean) =>
    cn(
      "flex h-14 w-full items-center justify-center rounded-xl transition active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-blue-500/60",
      active
        ? "bg-blue-600 text-white shadow-md"
        : "border border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800"
    );

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-[1000] border-t border-slate-800 bg-slate-950/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
      aria-label="Hovednavigasjon"
    >
      <div className="mx-auto max-w-md px-5 pt-3 pb-3">
        <div className="grid grid-cols-4 gap-2">
          <button
            type="button"
            onClick={() => router.push("/dashboard")}
            className={navBtn(tab === "dashboard")}
            aria-label="Dashboard"
            title="Dashboard"
          >
            <LayoutDashboard className="h-5 w-5" />
          </button>

          <button
            type="button"
            onClick={() => router.push("/clubs")}
            className={navBtn(tab === "clubs")}
            aria-label="Klubber"
            title="Klubber"
          >
            <Club className="h-5 w-5" />
          </button>

          <button
            type="button"
            onClick={() => router.push("/members")}
            className={navBtn(tab === "members")}
            aria-label="Medlemmer"
            title="Medlemmer"
          >
            <Users className="h-5 w-5" />
          </button>

          <button
            type="button"
            onClick={() => router.push("/settlements")}
            className={navBtn(tab === "settlements")}
            aria-label="Oppgjør"
            title="Oppgjør"
          >
            <Wallet className="h-5 w-5" />
          </button>
        </div>
      </div>
    </nav>
  );
}